export const URLS = {
    API_ENDPOINT:process.env.REACT_APP_URL_ENDPOINT,
    UPLOADS_URL:process.env.REACT_APP_URL_UPLOADS_URL,
    API_BOOKING_ENDPOINT:process.env.REACT_APP_URL_BOOKING_ENDPOINT,
    API_BELIEVE:process.env.REACT_APP_URL_BELIEVE,
    API_NEW:process.env.REACT_APP_URL_NEW,
    
};

